import { render, staticRenderFns } from "./DeleteMass.vue?vue&type=template&id=2ba6942a&"
import script from "./DeleteMass.vue?vue&type=script&lang=js&"
export * from "./DeleteMass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports